import { render } from "./IconCalendarToday.vue?vue&type=template&id=c769a2e0"
import script from "./IconCalendarToday.vue?vue&type=script&lang=js"
export * from "./IconCalendarToday.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__